<app-selector label="Videos" [isEmptySelectable]="isEmptySelectable" [data]="videoCoreService.videoList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="videoCoreService.loading" [hint]="hint">
</app-selector>